<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="short_text"
            name="name"
            v-model="form.name"
            :label="$t('delivery.promo.labels.name')"
            :placeholder="$t('delivery.promo.labels.name')"
            :error="hasInputErrors('name')"
            :error-messages="getInputErrors('name')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="paid"
            name="price"
            v-model.number="form.price"
            type="number"
            :label="$t('delivery.promo.labels.price')"
            :placeholder="$t('delivery.promo.labels.price')"
            :error="hasInputErrors('price')"
            :error-messages="getInputErrors('price')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <calendar-combobox
            v-model="form.calendar"
            clearable
        ></calendar-combobox>

      </v-col>

      <v-col cols="12" sm="6">
        <v-combobox
            :items="['DELIVERY','TAKE_AWAY','SALON']"
            multiple
            prepend-icon="paid"
            name="mode"
            v-model.number="form.mode"
            type="number"
            :label="$t('delivery.promo.labels.mode')"
            :placeholder="$t('delivery.promo.labels.mode')"
            :error="hasInputErrors('mode')"
            :error-messages="getInputErrors('mode')"
            color="secondary"
            :rules="required"
        ></v-combobox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="task_alt"
            name="active"
            v-model="form.active"
            :label="$t('delivery.promo.labels.active')"
            :error="hasInputErrors('active')"
            :error-messages="getInputErrors('active')"
            color="secondary"

        ></v-checkbox>
      </v-col>



      <v-col cols="12" sm="12">
        <media-field
            icon="photo_camera"
            fieldName="image"
            :label="$t('delivery.product.labels.image')"
            :placeholder="$t('delivery.product.labels.image')"
            v-model="form.image"
            :is-required="true"
        >

        </media-field>
      </v-col>

      <v-col cols="12">
        <h3 class="title">Categorías y Productos</h3>
        <v-divider></v-divider>
        <form-list
            :min-length="1"
            :new-item="{
                            category: '',
                            quantity: '',
                            products: []
                          }"
            :value="form.config"
        >

          <template v-slot:default="{index}">
            <promo-config-form
                v-model="form.config[index]"
            ></promo-config-form>
          </template>


        </form-list>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule, FormList} from '@dracul/common-frontend'
import {MediaField} from '@dracul/media-frontend'

import PromoConfigForm from "@/modules/delivery/forms/PromoForm/PromoConfigForm.vue";
import CalendarCombobox from "@/modules/calendar/combobox/CalendarCombobox/CalendarCombobox.vue";


export default {
  name: "PromoForm",
  components: {CalendarCombobox, PromoConfigForm, MediaField, FormList},
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    save() {
      this.$emit('save', this.form)
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

